import { useMutation } from '@tanstack/react-query';
import { captureData } from '../api/client';

export const useCaptureShoppingCart = () => {
    const { mutateAsync: captureShoppingCart } = useMutation({
        mutationFn: ({ shoppingCart, capturedSections }: { shoppingCart: any, capturedSections: any }) => {
            return captureData({ shoppingCart, capturedSections });
        },
    });

    return captureShoppingCart;
}